import { render, staticRenderFns } from "./OrderPanel.vue?vue&type=template&id=e569fc94&scoped=true"
import script from "./OrderPanel.vue?vue&type=script&lang=js"
export * from "./OrderPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderPanel.vue?vue&type=style&index=0&id=e569fc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e569fc94",
  null
  
)

export default component.exports